import styled from 'styled-components';
import { ContainerSection } from '../styles';

interface IAreaForm {
  gridTemplateColumns?: string;
}

export const Container = styled(ContainerSection)``;

export const HeaderText = styled.h4`
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const AreaForm = styled.div<IAreaForm>`
  background-color: #eaeaea;
  padding: 1rem;
  border-radius: 6px;
  margin: 0 0 2rem 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;

  @media (max-width: 768px) {
    > button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }

    &:last-child {
      grid-template-columns: 1fr;
    }
  }
`;

export const AreaButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 768px) {
    flex-direction: column;
    > button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }
`;
